<template>
  <vs-table
    :multiple="multiple"
    no-data-text="No tienes documentos"
    v-model="documentsSelected"
    :data="documents"
    class="table"
  >
    <template slot="thead">
      <vs-th>Tipo documento</vs-th>
      <vs-th>Nº documento</vs-th>
      <vs-th>Monto</vs-th>
      <vs-th>Emitida por</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
        <vs-td :data="data[indextr].documentType">
          {{tr.documentType.label}}
        </vs-td>
        <vs-td :data="data[indextr]">
          {{tr.documentNumber}}
        </vs-td>
        <vs-td :data="data[indextr]">
          {{tr.amount | amount}}
        </vs-td>
        <vs-td :data="data[indextr]">
          {{tr.emitedBy}}
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
export default {
  data() {
    return {
      documentsSelected: this.value || []
    };
  },
  watch: {
    documentsSelected() {
      this.$emit('input', this.documentsSelected);
    },
    value(newValue) {
      this.documentsSelected = newValue;
    }
  },
  props: {
    documents: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
